import { SingleValue } from '@any-ui-react/select';

import { Option } from '../../../types';

import { ValueEditorInputProps } from './useValueEditor';

interface UseAsyncSelectEditorReturnProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAsyncSelectEditorValue: (i?: number) => any | undefined;
  handleAsyncSelectEditorValueChange: () => (newValue: SingleValue<Option<string>>) => void;
}

export const useAsyncSelectEditor = ({
  values,
  handleSingleValue,
}: ValueEditorInputProps): UseAsyncSelectEditorReturnProps => {
  return {
    getAsyncSelectEditorValue: (i = 0) => {
      return values?.[i];
    },
    handleAsyncSelectEditorValueChange: () => {
      return (option) => handleSingleValue(option?.value);
    },
  };
};
